<template>
  <div>
    <section class="relative">
      <x-glow :type="1" />
      <youtube-thubmnail-downloader-title />
      <youtube-thubmnail-downloader-error v-if="error.exists" @reset="reset" :error="error" />
      <youtube-thubmnail-downloader-input v-else @submit="submit" @reset="reset" v-model="input" :disabled="disabled" :loading="loading" :error="error" />
    </section>
  </div>
</template>

<script lang="ts">
import YoutubeThubmnailDownloaderTitle from "../components/youtube.thubmnail.downloader.title.vue";
import YoutubeThubmnailDownloaderInput from "../components/youtube.thubmnail.downloader.input.vue";
import YoutubeThubmnailDownloaderError from "../components/youtube.thubmnail.downloader.error.vue";

import * as api from "../code/youtube.thumbnail.downloader.definitions.api";
import * as app from "../code/youtube.thumbnail.downloader.definitions.app";
import * as www from "../code/youtube.thumbnail.downloader.definitions.www";

export default {
  components: { YoutubeThubmnailDownloaderInput, YoutubeThubmnailDownloaderTitle, YoutubeThubmnailDownloaderError },
  async setup() {
    www.seo.set.index.fn();
  },
  data() {
    return {
      loading: false,
      input: "" as any,
      error: www.error.create.fn()
    };
  },
  async mounted() {
    //
  },
  computed: {
    disabled() {
      return this.loading || this.error.exists;
    }
  },
  methods: {
    async submit() {
      try {
        this.loading = true;
        const router = useRouter();
        var id = app.fn.id(this.input);

        await router.push({ name: "youtube.thumbnail.downloader.show", params: { id: id } });
      } catch (e: any) {
        var failed = true;
        this.loading = false;

        if (e instanceof app.error) {
          if (e.message === app.definitions.error.message.INVALID_VIDEO_ID_OR_URL) {
            this.error.code = e.code;
            this.error.exists = true;
            this.error.message = e.message;

            failed = false;
          }
        }

        if (failed) {
          throw e;
        }
      }
    },
    reset() {
      www.error.reset.fn(this.error);
    }
  }
};
</script>
